import z from 'zod';
import { firmPaymentMethodTypeValue, } from '../value-objects/firm-payment-method-type';
export const firmPaymentMethodSummarySchema = z.object({
    last4: z.string().length(4),
    type: firmPaymentMethodTypeValue,
});
//# sourceMappingURL=firm-payment-method-summary.js.map